// extracted by mini-css-extract-plugin
export default {"refreshBackground":"BillsSummarySection_refreshBackground__TuUc+","pointerContainer":"BillsSummarySection_pointerContainer__3bZNf"};